import React, { useState } from 'react';
import { PolicyDetailsProps } from '@components/Sura/PaymentDetails/PolicyDetail/types';
import useStyles from '@components/Sura/PaymentDetails/styles';
import IconButton from '@material-ui/core/IconButton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Typography } from '@material-ui/core';
import { formattedAmount } from '@utils/format';
import useStore from '@hooks/useStore';

const PolicyDetail: React.FC<PolicyDetailsProps> = ({ contract }) => {
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const [policyDetail, setPolicyDetail] = useState<boolean>(false);

  const handleExpandDetail = () => {
    setPolicyDetail((prev) => !prev);
  };

  const getDecimalNumber = (number: string) => {
    return `${number.slice(0, -2)}.${number.slice(-2)}`;
  };

  return (
    <div className={css.divPoliza}>
      <div className={css.divIcon}>
        <div>
          <Typography className={css.labelPoliza}>Póliza: {contract.policyId}</Typography>
          {contract.solution && (
            <Typography className={css.labelPoliza}>{contract?.solution}</Typography>
          )}
        </div>

        {policyDetail ? (
          <IconButton className={css.iconButton} onClick={handleExpandDetail}>
            <ExpandLessIcon className={css.icon} />
          </IconButton>
        ) : (
          <IconButton className={css.iconButton} onClick={handleExpandDetail}>
            <ExpandMoreIcon className={css.icon} />
          </IconButton>
        )}
      </div>
      {policyDetail &&
        contract.invoices.map((invoice, index) => (
          <div className={css.divReceipt} key={index}>
            <Typography className={css.labelReceipt}>Recibo {invoice.name}</Typography>
            <Typography className={css.labelTotalReceipt}>
              {formattedAmount(getDecimalNumber(invoice.price), 'MXN')}
            </Typography>
          </div>
        ))}
    </div>
  );
};

export default PolicyDetail;
